import styled from '@emotion/styled';
import { Alert, AlertTitle, Box, Card, Divider, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux';
import { theme } from '../../../commons/theme';

export const DetalleSeguridadSocial = () => {


  const { employee }:any  = useSelector( (state:any) => state.employee );


  const Item = styled(Paper)(({ theme }:any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
  }));


  return (
    <>
    
    <Alert severity="info">
      <AlertTitle>Info</AlertTitle>
        Aquí podrás descargar copia de los documentos Digitalizados de los colaboradores de tu organización, 
        solo presiona descargar en el botón del documento correspondiente y revisa en tu carpeta de descargas.
    </Alert>


    <Grid container spacing={1} sx={{ marginTop: 3 }}>


      {/* *********** */}
      <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} >Afiliacion</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Nombre</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Estado</Typography>
          </Box>
        </Grid>

        <Grid item xs={3} style={{textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5, fontWeight: 'bold' }} > Documento Soporte </Typography>
          </Box>
        </Grid>
        {/* ********** */}




{/* *********** */}
<Grid item xs={3} style={{textAlign: 'center',padding: 0, borderLeft: '3px solid #663cc1'}} sx={{ marginTop: 4 }}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >Arl</Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > { employee.familyCompensationFund.name } </Typography>
          </Box>
        </Grid>
        <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >  { ( employee.familyCompensationFund.name && employee.familyCompensationFund.name != "" ) ? 'Disponible' : 'N/A' } </Typography>
          </Box>
        </Grid>

        <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > Documento Soporte </Typography>
          </Box>
        </Grid>
        {/* ********** */}
      
         
         {/* *********** */}
          <Grid item xs={3} style={{textAlign: 'center',padding: 0, borderLeft: '3px solid #663cc1'}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >Caja de compensación</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > { employee.familyCompensationFund.name } </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >  { ( employee.familyCompensationFund.name && employee.familyCompensationFund.name != "" ) ? 'Disponible' : 'N/A' } </Typography>
              </Box>
            </Grid>

            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > Documento Soporte </Typography>
              </Box>
        </Grid>
        {/* ********** */}

      
        
        {/* *********** */}
        <Grid item xs={3} style={{textAlign: 'center',padding: 0, borderLeft: '3px solid #663cc1'}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >Cesantias</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > { employee.saving.name } </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >  { ( employee.saving.name && employee.saving.name != "" ) ? 'Disponible' : 'N/A' } </Typography>
              </Box>
            </Grid>

            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > Documento Soporte </Typography>
              </Box>
        </Grid>
        {/* ********** */}


        
        {/* *********** */}
        <Grid item xs={3} style={{textAlign: 'center',padding: 0, borderLeft: '3px solid #663cc1'}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >Eps</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > { employee.eps.name } </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >  { ( employee.eps.name && employee.eps.name != "" ) ? 'Disponible' : 'N/A' } </Typography>
              </Box>
            </Grid>

            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > Documento Soporte </Typography>
              </Box>
        </Grid>
        {/* ********** */}
      
      
        
         {/* *********** */}
        <Grid item xs={3} style={{textAlign: 'center',padding: 0, borderLeft: '3px solid #663cc1'}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >Pensiones</Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > { employee.retirement.name } </Typography>
              </Box>
            </Grid>
            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} >  { ( employee.retirement.name && employee.retirement.name != "" ) ? 'Disponible' : 'N/A' } </Typography>
              </Box>
            </Grid>

            <Grid item xs={3} style={{textAlign: 'center',padding: 0}} sx={{ marginTop: 4 }}>
              <Box
                  sx={{
                    textAlign: 'center',
                    height: '100%',
                    alignContent: 'center'
                  }}
                >
                <Typography sx={{ fontSize: '1rem', padding: 0.5 }} > Documento Soporte </Typography>
              </Box>
        </Grid>
        {/* ********** */}




    </Grid>

    
    </>
  )
}
